document.addEventListener("DOMContentLoaded", function () {
  waitForElm(".yotpo-reviews-star-ratings-widget").then(() => {
    initProductStarRatingObserver();
  });
  initCustomerReviewStarObserver();
});

function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

function initProductStarRatingObserver() {
 const processedWidgets = new WeakSet();
  const observer = new MutationObserver(function (mutationsList, obs) {
    const widgets = document.querySelectorAll(
      ".yotpo-reviews-star-ratings-widget"
    );

    if (!widgets.length) return;

    widgets.forEach((widget) => {
      if (processedWidgets.has(widget)) return;
      processedWidgets.add(widget);


      requestAnimationFrame(() => {
        const summary = widget.querySelector(".yotpo-sr-bottom-line-summary");
        const reviewTextElement = widget.querySelector(
          ".yotpo-sr-bottom-line-text"
        );

        if (!summary || !reviewTextElement || summary.innerHTML.trim() === "") return;

        const starContainers = summary.querySelectorAll(
          ".star-container.yotpo-sr-star-full"
        );
        const starRating = starContainers.length;

        let reviewCount = 0;
        const ariaLabel = reviewTextElement.getAttribute("aria-label");
        if (ariaLabel) {
          const match = ariaLabel.match(/\d+/);
          if (match) {
            reviewCount = parseInt(match[0], 10);
          }
        }

        if (reviewCount >= 1000) {
          const roundDown = Math.floor(reviewCount / 100) * 100;
          const formatted = (roundDown / 1000).toFixed(1);
          reviewTextElement.textContent = `${formatted}K Reviews`;
          reviewTextElement.setAttribute("aria-label", `${formatted}K Reviews`);
        }

        const showRating =
          starRating &&
          ((starRating >= 3 && reviewCount >= 10) ||
            (starRating >= 4 && reviewCount > 0));

        if (!showRating) {
          widget.classList.add("hide-rating-widget");
        }

        if (!summary.dataset.scrollBound) {
          summary.dataset.scrollBound = "true";
          summary.addEventListener("click", function (e) {
            e.preventDefault();
            const reviewsSection = document.querySelector("#yotpo-reviews-main-widget");
            if (reviewsSection) {
              reviewsSection.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function addAriaLabelToYotpoElements() {
  document.querySelectorAll(".yotpo-main-widget-layout").forEach((container) => {
    const svgStars = container.querySelectorAll(".yotpo-star-rating-icon");
    const svgPagination = container.querySelectorAll(".yotpo-reviews-pagination-container .yotpo-reviews-pagination-item svg");
    const svgFilterArrow = container.querySelector(".yotpo-dropdown-arrow-icon");
    const svgSearchIcon = container.querySelector(".yotpo-icon-button__icon svg");

    svgStars.forEach((svg, index) => {
      let starNumber;
      if (svg.classList.contains('yotpo-sr-star-full')) {
        starNumber = index + 1;
      } else if (svg.classList.contains('yotpo-sr-star-half')) {
        starNumber = index + .5;
      }

      if (!svg.hasAttribute("aria-label")) {
        svg.setAttribute("role", "img");
        svg.setAttribute("aria-label", `Star ${starNumber} out of 5`);
      }
    });

    svgPagination.forEach((svg) => {
      if (!svg.hasAttribute("aria-label")) {
        svg.setAttribute("aria-label", `Go to more reviews`);
      }
    });

    svgFilterArrow?.setAttribute("aria-label", "reviews sort dropdown arrow");
    svgSearchIcon?.setAttribute("aria-label", "reviews search icon");

    container.querySelectorAll(".yotpo-pagination-item .PREV").forEach((svg) => {
      if (!svg.hasAttribute("aria-label")) {
        svg.setAttribute("aria-label", "Navigate to previous page");
      }
    });

    container.querySelectorAll(".yotpo-pagination-item svg").forEach((svg) => {
      if (!svg.hasAttribute("aria-label")) {
        svg.setAttribute("aria-label", "Navigate to page");
      }
    });

    container.querySelectorAll('.yotpo-selected-icon').forEach((svg) => {
      if (!svg.hasAttribute("aria-label")) {
        svg.setAttribute("aria-label", "See review options");
      }
    });

    container.querySelectorAll('.yotpo-selected-icon').forEach((svg) => {
      if (!svg.hasAttribute("aria-label")) {
        svg.setAttribute("aria-label", "See review options");
      }
    });
  });


  document.querySelectorAll(".yotpo-widget-instance .yotpo-answers-extra-arrow").forEach((svg) => {
    if (!svg.hasAttribute("aria-label")) {
      svg.setAttribute("role", "img");
      svg.setAttribute("aria-label", "Show more answers to this question");
    }
  });

}

function initCustomerReviewStarObserver() {
  waitForElm(".yotpo-main-widget-layout").then((root) => {
    addAriaLabelToYotpoElements();

    const reviewObserver = new MutationObserver(() => {
      addAriaLabelToYotpoElements();
    });

    reviewObserver.observe(root, {
      childList: true,
      subtree: true,
    });
  });
}